import {BreakpointObserver} from '@angular/cdk/layout';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ScreenService {
    constructor(private breakpointObserver: BreakpointObserver) {
    }

    isMobileScreen(): boolean {
        return this.breakpointObserver.isMatched('(max-width: 767px)');
    }
}
